require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./people-will-forget-3.json") })
        }
      }, "path---people-will-forget-3");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---people-will-forget-3!./.cache/json/people-will-forget-3.json
// module id = 845
// module chunks = 231608221292675